
                                module.exports = new Proxy({}, {
                                    get: function() {
                                        const shouldLog = window?.posthog?.config?.debug
                                        if (shouldLog) {
                                            console.warn('[TOOLBAR] Attempted to use denied module:', "lib/monaco/CodeEditor");
                                        }
                                        return function() {
                                            return {}
                                        }
                                    }
                                });
                            